import type {
  JobTrackService,
  TrackGeoJson,
} from "@/domain/port/JobTrackService";
import { HttpClient } from "@/infrastructure/HttpClient";

export class JobTrackServiceImpl implements JobTrackService {
  constructor(private readonly http: HttpClient) {}

  async getTrackGeoJson(jobId: string): Promise<TrackGeoJson> {
    return this.http.request<TrackGeoJson>(`/api/jobs/${jobId}/track.geojson`, {
      method: "GET",
      headers: {
        Accept: "application/geo+json, application/json",
      },
    });
  }
}
